module.exports = __webpack_public_path__ + "static/hkgrotesk-bold-8719b97274de7c1c68c5f8ae32283ae8.woff";